import React, { useEffect, useState } from "react";
import { addToken, searchUser } from "./apiService";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./auth";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  // const [users, setUsers] = useState("[]");
  const navigate = useNavigate();
  const { login, userId } = useAuth();

  useEffect(() => {
    addToken();
  }, []);

  const handleLoginSubmit = async () => {
    let errors = {};
    if (!username) errors.username = "User name is required";
    if (!password) errors.password = "Password is required";

    try {
      console.log(localStorage.getItem("refresh_token"));
      let user = await searchUser(username, password);
      // console.log(user);

      const found = user.find((user) => {
        if (
          (user.username === username || user.email === username) &&
          user.password === password
        ) {
          userId(user.id);
          return true;
        } else {
          return false;
        }
      });

      // console.log(found);
      if (!found) errors.login = "Invalid Username or password";

      // console.log(errors.login);
      if (found) {
        // alert("User Login successful");
        login(username);

        navigate("/MyDashboard", { replace: true });
      }

      setErrors(errors);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="container-box">
      <div className="container">
        <div className="header">Login Here...</div>
        <div className="login-banner">
          User Name and Password are case sensitive
        </div>
        <div className="label">
          UserName or Email:
          <input
            type="text"
            className="inputbox"
            name="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          {errors.username ? (
            <div className="errortext">{errors.username}</div>
          ) : null}
        </div>

        <div className="label">
          Enter Password:
          <input
            type="password"
            className="inputbox"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {errors.password ? (
            <div className="errortext">{errors.password}</div>
          ) : null}
        </div>
        {errors.login ? <div className="errortext">{errors.login}</div> : null}
        <input
          type="submit"
          className="btn-cls"
          value="Login"
          onClick={handleLoginSubmit}
        />
        <div className="label1">
          Not Registered Yet.? Please
          <span onClick={() => navigate("/Register")}> Register</span> here..
        </div>
      </div>
    </div>
  );
};

export default Login;
